import React, { useEffect } from 'react';
import { MessageConfirm } from '@app/src/common/MessageConfirm';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { CATEGORIES, CATEGORY } from '@app/src/config/categories';
import { isClientEnv } from '@app/src/utils/validations';

const isClient = isClientEnv();

export const PaymentConfirm: React.FC = () => {
  const history = useHistory();
  const confirmData = useSelector(state => state.payment.confirm);
  const order = useSelector(state => state.payment.confirm.order);
  const date = useSelector(state => state.payment.confirm.date);
  const price = useSelector(state => state.payment.confirm.price);
  const print = isClient && JSON.parse(sessionStorage.getItem('print'));
  const getCategory = () => print && print.general && print.general.category;
  const categoryConfig = CATEGORIES[CATEGORY[getCategory()]];
  
  useEffect(() => {
    if (Object.keys(confirmData).length > 0) {
      pushDatalayer(categoryConfig.name);
    } else {
      history.push('/');
    }
  }, []);

  const pushDatalayer = (categoryName: string) => {
    if (isClient && (window as any).dataLayer) {
      (window as any).dataLayer.push({
        'event': 'EVClasificados',
        'eventCategory': `Confirmación de Pago - ${categoryName} - Tarjeta`,
        'eventAction': `Paso 4 - ${categoryName}`,
        'eventLabel': `${order}|${date}|S/ ${price}`,
        'eventValue': 1
      })
    }
  };

  return(
    Object.keys(confirmData).length > 0 && <MessageConfirm
      imgSrc={categoryConfig && categoryConfig.successImage}
      title="Tu compra se realizó con éxito"
      message="Recuerda que la publicación de tu aviso impreso está sujeto al pago antes de la fecha de cierre de publicación de la edición seleccionada."
      buttonText="Crear nuevo aviso"
      theme={categoryConfig && categoryConfig.color}
      redirect={categoryConfig && `${categoryConfig.link}-1`}
      details={{
        order,
        date,
        price
    }}
  />
)};
